import { __ } from '@wordpress/i18n';
import { 
  PanelBody, 
  SelectControl,
  __experimentalBoxControl as BoxControl, 
} from "@wordpress/components";

import { useEffect, useState } from '@wordpress/element';

import borderStyles from '../assets/borderStyles';
import defaultColors from '../assets/defaultColors';

import ColorControl from './color-control';

function BorderControl(props) {
  const borderWidthString = props.value?.borderWidth?.split(' ');

  const [borderWidth, setBorderWidth] = useState({
    top: borderWidthString[0],
    right: borderWidthString[1],
    bottom: borderWidthString[2],
    left: borderWidthString[3]
  });
  const [borderStyle, setBorderStyle] = useState(props.value.borderStyle);
  const [borderColor, setBorderColor] = useState(props.value.borderColor);

  useEffect(() => {
    props.onChange({
      borderWidth: `${borderWidth.top} ${borderWidth.right} ${borderWidth.bottom} ${borderWidth.left}`,
      borderStyle,
      borderColor
    });
  }, [
    borderColor,
    borderStyle,
    borderWidth
  ]);

  return (
    <PanelBody title={__('Border')} initialOpen={false}>
      <BoxControl
        value={borderWidth}
        onChange={setBorderWidth}
      />
      <SelectControl 
        options={borderStyles}
        value={borderStyle}
        onChange={setBorderStyle}
      />
      <ColorControl 
        label={__('Border color')}
        value={borderColor}
        onChange={setBorderColor}
        colors={defaultColors}
      />
    </PanelBody>
  );
}

export default BorderControl;